import { useState } from 'react'
import { Link } from 'gatsby'
import cn from 'clsx'
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FunFactWrap, FunFactTitle, FunFactCount, FunFactText } from './style'

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

const Counter = ({
  title,
  countTo,
  text,
  icon,
  path,
  className,
  layout,
  ...restProps
}) => {
  const [focus, setFocus] = useState(false)
  const visibleChangeHandler = (isVisible) => {
    if (isVisible) {
      if (!focus) {
        setFocus(true)
      }
    }
  }

  return (
    <FunFactWrap
      className={cn(className, 'fun-fact')}
      $layout={layout}
      {...restProps}
    >
      {title && <FunFactTitle dangerouslySetInnerHTML={{ __html: title }} />}
      {countTo && (
        <FunFactCount $layout={layout}>
          <ConditionalWrapper
            condition={path !== null}
            wrapper={(wrappedChildren) => (
              <Link to={path}>{wrappedChildren}</Link>
            )}
          >
            <div style={{ pointerEvents: path ? 'none' : 'auto' }}>
              <FontAwesomeIcon
                icon={icon}
                style={{ marginRight: '20px' }}
                size="sm"
              />
              <CountUp start={focus ? 0 : null} end={countTo} duration={5}>
                {({ countUpRef }) => (
                  <div ref={countUpRef} style={{ display: 'inline' }} />
                )}
              </CountUp>
              <VisibilitySensor
                delayedCall
                onChange={(isVisible) => visibleChangeHandler(isVisible)}
              >
                <span className="sr-only">+</span>
              </VisibilitySensor>
            </div>
          </ConditionalWrapper>
        </FunFactCount>
      )}
      {text && (
        <FunFactText
          $layout={layout}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </FunFactWrap>
  )
}

export default Counter
